export default __webpack_public_path__ + "static/media/clicks.f298fbd9.svg";